import styled from 'styled-components';
import { ResponsiveWidth } from '../../../../components/Css';
import { Typography } from 'antd';

const {Text} = Typography;

export const WelcomeContainer = styled.div`
    //padding: var(--spacing-regular);
    text-align: center;
    display: grid;
    place-items: center;
    height: 100%;
    min-height: 100vh;
`;

export const ImageWrapper = styled.div`
    margin-bottom: var(--spacing-regular);
    height: var(--logotipo-height);
    margin-top: var(--spacing-regular);
`;

export const ImageContainer = styled.div`
    //height: calc(100vh - 300px);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Img = styled.img`
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    @media (max-width: 1280px) {
        max-width: 70%;
    }
`;

export const WelcomeFooter = styled.div`
    width: 500px;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-regular);

    @media (max-width: ${ResponsiveWidth}px) {
        width: 300px
    }
`;

export const LinkText = styled(Text)`
    font-weight: bold;
    cursor: pointer;
    color: var(--colorSecondary);
    font-size: var(--font-medium);
`;

export const LinkRegister = styled.div`
    color: var(--color-button-text);
    font-size: var(--font-big);
`

export const LinkCopyRigth = styled(LinkText)`
    font-size: var(--font-small);
`
